import { cn, Loading } from "@mozioinc/ui";
import { ErrorBoundary } from "@sentry/react";
import { Suspense } from "react";
import { Footer, GeneralError } from "../components";
import { Header } from "./header";
import type { ReactNode } from "react";

type LayoutProps = {
  children: ReactNode;
  className?: string;
};

const Layout = ({ children, className }: LayoutProps) => (
  <div
    className={cn(
      "flex min-h-screen flex-col pt-[var(--mz-header-height)]",
      className,
    )}
  >
    <Header />
    <Suspense fallback={<Loading className="min-h-screen" />}>
      <ErrorBoundary fallback={<GeneralError className="h-screen flex-1" />}>
        <>{children}</>
      </ErrorBoundary>
    </Suspense>
    <Footer />
  </div>
);

export { Layout };
